/** Firebase Web 공개 설정 (FCM 푸시 토큰 발급용) */
export const FIREBASE_WEB_APP_CONFIG = {
  apiKey: "AIzaSyBMubUnZcS6a7Ngpw5okF08SFx3GKGcm1Q",
  authDomain: "ject-vs-48246.firebaseapp.com",
  projectId: "ject-vs-48246",
  storageBucket: "ject-vs-48246.firebasestorage.app",
  messagingSenderId: "712416945522",
  appId: "1:712416945522:web:dd8c372c87e48f7af9e9eb",
} as const;

export const FIREBASE_VAPID_KEY =
  "BMSJh_-zEZ2eWxd4rHbH0YswrljRgRgywRzI0VrGGrJgSQv-UaVaQr706lVaQVRJZkU56p38t-viprTtMauKI3w";
